var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "form",
    attrs: {
      layout: "inline",
      model: _vm.form,
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: _vm.$t("模板名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入模板名称")
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1)], 1), _c("a-row", [_c("a-form-model-item", {
    staticStyle: {
      width: "100%",
      "margin-top": "15px"
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.onSearch
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("customer.noticeTemplateStore") ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.openAddModal(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("新增模板")) + " ")]) : _vm._e()], 1)], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (text, record) {
        return [_vm.isAuth("customer.noticeTemplateStatus") ? _c("a-switch", {
          on: {
            change: function ($event) {
              return _vm.handleStatusChange(record);
            }
          },
          model: {
            value: record.status,
            callback: function ($$v) {
              _vm.$set(record, "status", $$v);
            },
            expression: "record.status"
          }
        }) : _c("span", [_vm._v(_vm._s(record.status ? "启用" : "停用"))])];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [_vm.isAuth("customer.noticeTemplateEdit") ? _c("a-button", {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            type: "edit"
          },
          on: {
            click: function ($event) {
              return _vm.openAddModal(true, record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("编辑")) + " ")]) : _vm._e(), _vm.isAuth("customer.noticeTemplateDelete") ? _c("a-button", {
          attrs: {
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.openDeleteModal(record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("删除")) + " ")]) : _vm._e()];
      }
    }])
  }), _c("a-modal", {
    attrs: {
      title: _vm.noticeTemplateForm.id ? _vm.$t("编辑模板") : _vm.$t("新增模板"),
      maskClosable: false,
      visible: _vm.addVisible,
      width: 600,
      rowKey: "index",
      cancelButtonProps: {
        style: {
          display: "none"
        }
      }
    },
    on: {
      cancel: _vm.closeAddVisible
    }
  }, [_c("a-form-model", {
    ref: "noticeTemplateForm",
    attrs: {
      model: _vm.noticeTemplateForm,
      rules: _vm.noticeTemplateFormRules,
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: _vm.$t("模板名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入模板名称")
    },
    model: {
      value: _vm.noticeTemplateForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.noticeTemplateForm, "name", $$v);
      },
      expression: "noticeTemplateForm.name"
    }
  })], 1), _c("a-form-model-item", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: _vm.$t("模板文件地址"),
      prop: "content"
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      "file-list": _vm.fileList,
      "before-upload": _vm.beforeUpload,
      accept: ".doc,.docx",
      "list-type": "picture-card",
      data: {
        module: "fileTemplate"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.fileList.length < 1 ? _c("div", [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + " ")])], 1) : _vm._e()])], 1), _c("a-form-model-item", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: _vm.$t("备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入备注")
    },
    model: {
      value: _vm.noticeTemplateForm.remark,
      callback: function ($$v) {
        _vm.$set(_vm.noticeTemplateForm, "remark", $$v);
      },
      expression: "noticeTemplateForm.remark"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.loading
    },
    on: {
      click: _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]), _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.handleConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };